import React, { useState } from "react";
import "./Header.scss";
import CommonButton from "../../components/CommonButton/CommonButton";
import { FaCircleInfo } from "react-icons/fa6";

const Header: React.FC = () => {
  const [loading, setLoading] = useState(false);

  const getUserInfo = () => {
    setLoading(false);
    alert("User Info clicked!");
  };

  return (
    <header className="header-container fixed-top">
      <div className="container-fluid common-padding-content pt-2 pb-2 d-flex justify-content-between">
        <div className="user-details-container d-flex">
          <a className="navbar-brand position-relative">
            <img
              className="chat-logo rounded-circle img-fluid"
              src="/assets/images/default_profile.png"
              alt="chat-logo"
            />
            <span className="online-dot"></span>
          </a>
          <div className="ms-2 user-details d-flex flex-column justify-content-center">
            <h3 className="common-size-18 text-start">Vinod Prakash</h3>
            <h5 className="common-size-14 text-start">Online</h5>
          </div>
        </div>
        <CommonButton
          btnText=""
          onClick={getUserInfo}
          loading={loading}
          height="80px"
          className="vertical-center common-size-25 info-btn"
          backgroundColor="transparent"
          border="none"
          color="#666"
          borderRadius="8px"
          icon={FaCircleInfo}
        />
      </div>
    </header>
  );
};

export default Header;
